
let recaptchaId = <number>null;

$("#WilsonPurchase").on("click", function () {
    checkoutRedirect();
})

$("#ExternalPurchase").on("click", function () {
    externalCheckoutRedirect(this.dataset.url);
})

export function checkoutRedirect() {
    window.location.href = `/Store/Checkout/${$("#ProductId").val()}${window.location.search}`;
}

export function externalCheckoutRedirect(url) {
    var confirmNavigationDialog = DevExpress.ui.dialog.custom({
        title: "Confirm Navigation",
        messageHtml: "<b>You are now leaving Wilson Language, do you wish to continue?</b>",
        buttons: [
            {
                text: "Ok",
                onClick: function () {
                    window.location.href = url;
                }
            },
            {
                text: "Cancel",
                onClick: function () {
                    confirmNavigationDialog.hide();
                }
            }
        ]
    });
    confirmNavigationDialog.show();
}

export function showNotifyModal() {
    const popup = $("#NotifyMePopup").dxPopup("instance");
    const isVisible = $("#NotifyMePopup").is(":visible")
    $("#ErrorMsg").hide();
    $("#Name").val("");
    $("#Email").val("");
    $("#SchoolOrg").val("");
    $("#Qty").val("");
    isVisible ? popup.hide() : popup.show();
}

export function addToNotifications() {
    let productId = $("#ProductId").val();
    let name = $("#Name").val();
    let email = $("#Email").val();
    let schoolOrg = $("#SchoolOrg").val();
    let qty = $("#Qty").val();
    const recaptchaElement = $("#recaptcha").get(0);
    $("ErrorMsg").hide();

    if (!name || !email) {
        $("#ErrorMsg").show();
        return;
    }

    let data = {
        ProductId: productId,
        Name: name,
        Email: email,
        SchoolOrOrganization: schoolOrg,
        Quantity: qty
    };

    if (recaptchaElement) {
        const recaptchaResponse = grecaptcha.enterprise.getResponse();
        data['g-recaptcha-response'] = recaptchaResponse;
    }

    $.ajax({
        type: "POST",
        url: window.location.href + "?handler=ToNotifications",
        data: data,
        beforeSend: function (xhr) {
            xhr.setRequestHeader("XSRF-TOKEN", <string>$("input:hidden[name='__RequestVerificationToken']").val());
        },
        success: function () {
            showNotifyModal();
            DevExpress.ui.notify("A notification has been added.", "success");
        },
        error: function (xhr) {
            let message = "Error creating notification, please try again.";
            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }
            DevExpress.ui.notify(message, "error");
        },
        complete: function (xhr) {
            if (recaptchaId !== null) {
                grecaptcha.enterprise.reset();
            }
        },
        timeout: 30000,
    });
}

export function initRecaptcha() {
    if (recaptchaId === null) {
        const container = $("#recaptcha");
        const element = container.get(0);
        const key = container.data("sitekey");
        if (element && key) {
            recaptchaId = grecaptcha.enterprise.render(container.get(0), { sitekey: key });
        }
    }
}

$(function () {
    const notifyMeBtn = $("#NotifyMeBtn");
    notifyMeBtn.on("click", showNotifyModal);
});
